const { WEB_VERSION } = process.env;

const COOKIE_KEY = {
  access_token: 'access_token',
  refresh_token: 'refresh_token',
  pin_token: 'pin_token',
  pin_refresh: 'pin_refresh',
  otp_token: 'otp_token',
  is_from_otp: 'is_from_otp',
  isFirstLoad: 'isFirstLoad',
  hashedHeader: 'hashed_header',
  redirect: 'redirect',
  pin_need_change: 'pin_need_change',
  deviceSign: 'x-device-signature',
  have_trusted_device: 'have_trusted_device',
  is_trusted_device: 'is_trusted_device',
  is_device_suspended: 'is_device_suspended',
  show_2fa: 'show_2fa',
  has_kyc: 'has_kyc',
  has_set_pin: 'has_set_pin',
  notification_token: 'notification_token',
  is_pin_6digit: 'is_pin_6digit',
};

const COOKIE_SECURE = { path: '/', domain: process.env.DOMAIN, secure: true };

const ERROR_CODE = {
  API: 'ERROR_API',
  WEBSOCKET: 'ERROR_WEBSOCKET',
};

const WEBSOCKET_CLOSE_CODE = {
  NORMAL: 1000,
};

const API_SUCCESS_CODE = 'EC0000000';
const DEFAULT_ERROR_MESSAGE = 'Ada yang salah, silahkan coba lagi';

const DEFAULT_GET_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: null,
};

const DEFAULT_POST_RESPONSE = {
  err_code: '500',
  err_message: '',
};

const DEFAULT_ERROR_RESPONSE = {
  err_code: '',
  err_message: '',
  result: null,
};

const ORDER_PERIOD = [
  {
    value: 'day',
    text: 'Hari',
    description: 'Order aktif sepanjang hari bursa yang sama',
  },
  {
    value: 'session',
    text: 'Sesi',
    description: 'Order aktif hanya sampai sesi perdagangan yang dipilih berakhir',
  },
];

const ACCOUNT_TYPE_OPTIONS = [
  {
    value: 'margin',
    text: 'Margin Trading',
  },
  {
    value: 'regular',
    text: 'Regular',
  },
  {
    value: 'daytrading',
    text: 'Day Trading',
  },
];

const PERCENTAGE = [
  {
    value: 0.25,
    label: '25%',
  },
  {
    value: 0.5,
    label: '50%',
  },
  {
    value: 0.75,
    label: '75%',
  },
  {
    value: 1,
    label: '100%',
  },
];

const FILTER_PERIOD = [
  { text: '1D', value: 'DAY', description: 'Hari Ini' },
  { text: '1W', value: 'WK1', description: 'Minggu Ini' },
  { text: '1M', value: 'M1', description: 'Bulan Ini' },
  { text: '3M', value: 'M3', description: '3 Bulan Terakhir' },
  { text: '1Y', value: 'YR1', description: '1 Tahun Terakhir' },
  { text: '5Y', value: 'YR5', description: '5 Tahun Terakhir' },
  { text: 'All', value: 'YR10', description: 'Semua Data' },
];

const FILTER_PERIOD_WITH_YTD = [
  { text: '1D', value: 'DAY', description: 'Hari Ini' },
  { text: '1W', value: 'WK1', description: 'Minggu Ini' },
  { text: '1M', value: 'M1', description: 'Bulan Ini' },
  { text: '3M', value: 'M3', description: '3 Bulan' },
  { text: '1Y', value: 'YR1', description: '1 Tahun' },
  { text: '5Y', value: 'YR5', description: '5 Tahun' },
  { text: 'All', value: 'YTD', description: 'Semua Data' },
  // { text: '10Y', value: 'YR10', description: '10 Tahun' },
];

// Withdrawal Reasons
const WITHDRAWAL_REASON = [
  'Sudah mencapai tujuan investasi',
  'Tidak nyaman dengan performa investasi yang diperoleh',
  'Membutuhkan dana darurat segera',
  'Ingin mengubah susunan investasi',
  'Lainnya',
];

const REFERRAL_BONUS_TYPE = {
  stock: 'stock',
  mutualFund: 'mutual-fund',
  fee: 'fee',
  rdn: 'rdn',
};

const INCOME = [
  'Di bawah Rp 1 juta',
  'Rp 1 hingga 4 juta',
  'Rp 4 hingga 8 juta',
  'Rp 8 hingga 20 juta',
  'Rp 20 hingga 40 juta',
  'Rp 40 hingga 85 juta',
  'Diatas Rp 85 juta',
  '',
];

const INVESTSTYLE = [
  'Risiko rendah, tingkat return rendah',
  'Risiko sedang, tingkat return sedang',
  'Risiko tinggi, tingkat return tinggi',
  '',
];

const INVESTMENT_TIME = [
  '< 1 tahun',
  '> 1 sampai 3 tahun',
  '> 3 sampai 9 tahun',
  '> 9 sampai 12 tahun',
  '> 12 tahun',
  '',
];

const FINANCIAL_BACKGROUND_SOURCE = [
  'Penghasilan Kerja',
  'Keuntungan bisnis',
  'Bunga simpanan',
  'Warisan',
  'Dari orang tua / anak',
  'Hibah',
  'Dana suami / istri',
  'Undian',
  'Keuntungan investasi',
  '',
];

const INVESTMENT_PURPOSE_OBJECTIVE = [
  'Mendapat keuntungan atas modal',
  'Membeli sesuatu di masa depan',
  'Spekulasi',
  'Mencari sumber penghasilan',
  '',
];

const FINANCIAL_BACKGROUND_EDUCATION_LEVEL = [
  'SD',
  'SMP',
  'SMA',
  'Diploma',
  'S1',
  'S2',
  'S3',
  'Pilih',
];

const INVESTMENT_EXPERIENCE = [
  'Tidak berpengalaman',
  'Sedikit berpengalaman',
  'Lumayan berpengalaman',
  'Sangat berpengalaman',
  '',
];

const RELIGION = [
  'Islam',
  'Protestan',
  'Katolik',
  'Hindu',
  'Buddha',
  'Kong Hu Chu',
  'Aliran kepercayaan',
  'Pilih',
];

const OCCUPATION = [
  'Pelajar/Mahasiswa',
  'Ibu rumah tangga',
  'Wiraswasta',
  'Pegawai Negeri Sipil',
  'TNI/Polisi',
  'Pensiunan',
  'Dosen/Guru',
  'Karyawan swasta',
  'Lainnya',
  'Pegawai BUMN/BUMD',
  'Pejabat Negara',
  'Pegawai Lembaga Negara',
  'Profesional',
  'Freelance',
];

const MARITAL = ['Belum Kawin', 'Kawin', 'Cerai', 'Pilih'];

const ECONOMY_SECTOR_CHOICE = [
  'Pilih bidang pekerjaan',
  'Konsultan Akunting, Pajak',
  'Elektronik, Komputer, Perangkat Lunak, Alat telekomunikasi',
  'Garmen dan tesktil',
  'Usaha Internet',
  'Konsultan Hukum',
  'Lembaga Keuangan Bukan Bank',
  'Perumahan / Properti',
  'Restoran',
  'Agen Perjalanan',
  'Organisasi Politik',
  'Lainnya',
];

const STATUS_KYC = {
  NOT_READY: 'NOT_READY',
  REJECT: 'REJECT',
  FAILED: 'FAILED',
  VERIFIED: 'VERIFIED',
  IN_PROCESS: 'IN_PROCESS',
  READY_FOR_DOWNLOAD: 'READY_FOR_DOWNLOAD',
  READY_TO_PROCESS: 'READY_TO_PROCESS',
  DOWNLOADED: 'DOWNLOADED',
};
const WA_MEMBER_PREMIUM_MESSAGE =
  'Halo, saya pemilik akun Ajaib Premium. Saya butuh bantuan mengenai...';

const ALPHABETS = '#ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const REGEX_IPO_FORM = /^home\/stocks\/IPO\/\w\w\w\w\/form$/g;

const RETURN_INFO_OPTIONS = [
  { text: 'Return 1 Bulan', value: '1M' },
  { text: 'Return 3 Bulan', value: '3M' },
  { text: 'Return 6 Bulan', value: '6M' },
  { text: 'Return 1 Tahun', value: '1Y' },
  { text: 'Return 3 Tahun', value: '3Y' },
  { text: 'Return All', value: 'All' },
];

const FETCH_STATUS = {
  INITIAL: 'INITIAL',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  NO_CONNECTION: 'NO_CONNECTION',
};

const ICON_AJAIB = 'https://static-i.ajaib.co.id/email_assets/ajaib-logo-fallback-blue.png';

const IMG_COMPANY_PLACEHOLDER =
  'https://cdn-stock.ajaib.co.id/image/PLACEHOLDER_6d8d8234-454f-42a3-939d-21ee807e9a2d.png';

const REMOTE_CONFIG_THROTTLE_MILLIS = process.env.FIREBASE_REMOTE_CONFIG_THROTTLE_MILLIS;

const { AES_ENCRYPTION_SECRET_KEY } = process.env;

const STOCK_CORP_ACTION_ANNOUNCEMENT_ENABLED = false;

const GENERIC_STORAGE_KEY = {
  layout: 'layout',
  tickerTabs: 'tickerTabs',
};

export {
  API_SUCCESS_CODE,
  COOKIE_KEY,
  COOKIE_SECURE,
  ERROR_CODE,
  WEBSOCKET_CLOSE_CODE,
  ORDER_PERIOD,
  PERCENTAGE,
  DEFAULT_ERROR_RESPONSE,
  DEFAULT_GET_RESPONSE,
  DEFAULT_POST_RESPONSE,
  FILTER_PERIOD,
  FILTER_PERIOD_WITH_YTD,
  WITHDRAWAL_REASON,
  REFERRAL_BONUS_TYPE,
  REMOTE_CONFIG_THROTTLE_MILLIS,
  FETCH_STATUS,
  INCOME,
  INVESTSTYLE,
  INVESTMENT_TIME,
  FINANCIAL_BACKGROUND_SOURCE,
  INVESTMENT_PURPOSE_OBJECTIVE,
  FINANCIAL_BACKGROUND_EDUCATION_LEVEL,
  INVESTMENT_EXPERIENCE,
  RELIGION,
  RETURN_INFO_OPTIONS,
  OCCUPATION,
  MARITAL,
  ECONOMY_SECTOR_CHOICE,
  STATUS_KYC,
  WA_MEMBER_PREMIUM_MESSAGE,
  ACCOUNT_TYPE_OPTIONS,
  ALPHABETS,
  REGEX_IPO_FORM,
  WEB_VERSION,
  DEFAULT_ERROR_MESSAGE,
  ICON_AJAIB,
  IMG_COMPANY_PLACEHOLDER,
  AES_ENCRYPTION_SECRET_KEY,
  STOCK_CORP_ACTION_ANNOUNCEMENT_ENABLED,
  GENERIC_STORAGE_KEY,
};
